import { useRef } from "react";
import { ResultOf } from "gql.tada";
import { IntroBenefitsSectionById } from "../../../queries/entries/IntroBenefitsSectionById";
import { useTransform, motion, MotionValue } from "motion/react";
import { useIsDesktop } from "../../../hooks/useIsDesktop";

export const PARALLAX_RATE = 0.25;

export const IntroBenefitPart = ({
  image,
  index,
  total,
  value,
}: {
  value: MotionValue<number>; // 0 to total
  image: string;
  total: number;
  index: number;
  isDesktop: boolean;
  benefitItem: NonNullable<
    NonNullable<
      ResultOf<typeof IntroBenefitsSectionById>["introBenefitsSection"]
    >["benefitItemsCollection"]
  >["items"][number];
  title: string;
}) => {
  const isMobile = !useIsDesktop();
  const isLastItem = total - 1 === index;
  const sectionRef = useRef<HTMLDivElement>(null);
  const valueMap = useTransform(value, [0, index, index + 1], [0, 0, 1]);
  const y = useTransform(() => {
    if (!isLastItem) return `-${valueMap.get() * PARALLAX_RATE * 100}%`;
    else return `${valueMap.get() * (1 - PARALLAX_RATE) * 100}%`;
  });

  return (
    <div
      className="overflow-hidden sticky top-0 w-full h-screen"
      ref={sectionRef}
    >
      <motion.img
        src={image || ""}
        alt={`Image ${index + 1}`}
        style={{ y: isMobile ? 0 : y }}
        className="size-full object-cover sticky top-0"
      />
    </div>
  );
};
